<template>
  <div class="user-text">
    <div class="toolBox">
      <chatEmoji :inp-message="content" :title="$t('表情')" @selectEmoji="selectEmoji" />
      <!-- <a-icon
        type="picture"
        class="imgBtn"
        :title="$t('图片')"
        @click="
          () => {
            $refs.fileDom.click()
          }
        "
      />
      <a-icon
        type="play-square"
        class="imgBtn"
        :title="$t('视频')"
        @click="
          () => {
            $refs.videoDom.click()
          }
        "
      /> -->
      <a-icon
        type="folder"
        class="imgBtn"
        :title="$t('文件')"
        @click="
          () => {
            $refs.fileDom.click()
          }
        "
      />
      <a-icon
        type="history"
        class="imgBtn"
        :title="$t('聊天记录')"
        @click="$emit('activationRightModule', 'chatRecord')"
      />

      <a-icon
        type="phone"
        class="imgBtn"
        :title="$t('音频')"
        style="position: absolute; right: 35px"
        @click="audioCall"
      />

      <a-icon
        type="video-camera"
        class="imgBtn"
        :title="$t('视频')"
        style="position: absolute; right: 0"
        @click="videoCall"
      />
    </div>
    <textarea
      ref="textarea"
      v-model.trim="content"
      :maxLength="2000"
      placeholder="Enter"
      @keyup.enter="handleSendBtn({ type: 'normal' })"
    />

    <!-- <input
      ref="fileDom"
      type="file"
      accept="image/*"
      style="display:none"
      @change="pictureChange"
    /> -->
    <input ref="fileDom" type="file" accept="*" style="display: none" @change="(e) => sendFile(e)" />
    <!-- <input
      ref="videoDom"
      type="file"
      accept="video/*"
      style="display:none"
      @change="(e) => sendPrivateFile(e, 'VIDEO')"
    /> -->
    <div class="seadRow">
      <a-button class="sendBtn" :disabled="!!!content" @click="handleSendBtn({ type: 'normal' })">
        {{ $t('发送') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import chatEmoji from './upload/emoji.vue'
import { setSaveChat } from '@/api/pushSend'

export default {
  name: 'ChatText',
  components: {
    chatEmoji,
  },
  data() {
    return {
      content: '',
    }
  },
  computed: {
    ...mapGetters({
      // 判断是否正式登录
      token: 'token',
      currentSession: 'chat/currentSession',
      currentUser: 'chat/currentUser',
      otherUserInfo: 'chat/otherUserInfo',
      // 游客信息
      visitorUser: 'chat/visitorUser',
      // 自己如果是游客的信息
      IMLoginInfo: 'chat/IMLoginInfo',
      // 是否登录成功
      isWebIMLogin: 'chat/isWebIMLogin',
    }),
  },
  methods: {
    ...mapActions({
      addMessage: 'chat/addMessage',
    }),
    /**
     * 点击发送按钮
     * 目前有两种情况, 一个是默认的正常发送, 另外一种是兄弟组件的重发
     */

    handleSendBtn({ incomeMsg }) {
      try {
        const that = this

        const id = incomeMsg && incomeMsg.id ? incomeMsg.id : this.$WebIM.conn.getUniqueId() // 生成本地消息id

        const msg = new this.$WebIM.message('txt', id) // 创建文本消息

        this.content =
          incomeMsg && incomeMsg.data ? incomeMsg.data.replace(/(^\s*)/g, '') : this.content.replace(/(^\s*)/g, '')

        const msgInfo = {
          id,
          from: this.currentUser.id || this.IMLoginInfo.ip,
          to: this.currentSession.id,
          contentsType: 'TEXT',
          data: this.content,
          time: new Date().getTime(),
          status: that.isWebIMLogin ? 'loading' : 'error',
        }

        if (this.content !== '') {
          this.content = ''
          msgInfo.is_self = 1
        } else {
          this.$message.error('消息不能为空!')
          return
        }

        const ext = {
          sendUrl:
            (that.currentUser.company && that.currentUser.company.logo) ||
            that.currentUser.avatar ||
            that.currentUser.selectedAvatarUrl ||
            '',
          sendName:
            (that.currentUser.company && that.currentUser.company.companyName) ||
            (that.currentUser.memberCard && that.currentUser.memberCard.contact) ||
            '',
          receiveUrl: that.otherUserInfo.pic || '',
          receiveName:
            that.otherUserInfo.companyName || that.otherUserInfo.contact || that.otherUserInfo.mchcompanyName || '',
          content: msgInfo.data || '',
          em_ignore_notification: '1',
          roleId: that.currentUser.roleId,
          memunicode: that.currentUser.memunicode,
          company: (that.currentUser.company && that.currentUser.company.companyName) || this.IMLoginInfo.ip || '',
        }

        msgInfo.ext = ext
        that.addMessage(msgInfo)

        msg.set({
          msg: msgInfo.data, // 消息内容
          to: that.otherUserInfo.huanxinId, // 接收消息对象（用户id）
          ext,
          roomType: 'singleChat',
          success(id, serverMsgId) {
            console.log('that.visitorUser', that.visitorUser)
            msgInfo.id = serverMsgId

            that.$store.commit('chat/updateMessageStatus', {
              id,
              serverMsgId,
              status: 'success',
            })

            const saveInfo = {
              toMemberCode:
                that.otherUserInfo.memunicode || that.otherUserInfo.memUnicode || that.otherUserInfo.huanxinId,
              lastMessage: msgInfo.data || '',
            }

            if (!that.token) {
              saveInfo.visitorHuanxinId = that.visitorUser.huanxinId
            }

            setSaveChat(saveInfo)
          }, // 对成功的相关定义,sdk会将消息id登记到日志进行备份处理
          fail(e) {
            console.log('发送失败', e)
            that.$message.error(e.reason || e.type)
            that.$store.commit('chat/updateMessageStatus', {
              id,
              status: 'error',
            })
          }, // 对失败的相关定义,sdk会将消息id登记到日志进行备份处理
        })

        console.log('本地id', id, msg.body)

        console.log('send前的', msg, msgInfo)

        this.$WebIM.conn.send(msg.body)
      } catch (err) {
        console.log('errSendPrivateText', err)
      }
    },
    // 发送表情包
    selectEmoji(v) {
      this.content = v
      this.$refs.textarea.focus()
    },
    // 发送文件时间, 判断类型并分发任务
    sendFile(e) {
      console.log('sendFile', e, e?.target?.files[0]?.type, e?.target?.files[0]?.type?.indexOf('image'))
      if (e?.target?.files[0]?.type?.indexOf('image') > -1) {
        this.pictureChange(e)
      } else if (e?.target?.files[0]?.type?.indexOf('video') > -1) {
        this.sendPrivateFile(e, 'VIDEO')
      } else {
        this.sendPrivateFile(e, 'FILE')
      }
    },
    // 发送图片
    pictureChange(e) {
      console.log('发送图片', e)
      try {
        const file = this.$WebIM.utils.getFileUrl(e.target)
        if (!file.filename) {
          this.$refs.fileDom.value = null
          return false
        }
        console.log('file', file)

        // 大小
        const isLt2M = file.data.size / (1024 * 1024) > 10
        if (isLt2M) {
          this.$message.error(this.$t('图片大小不可以超过 10MB!'))
          return
        }

        const id = this.$WebIM.conn.getUniqueId()
        const msg = new this.$WebIM.message('img', id)
        const that = this

        const ext = {
          sendUrl:
            (that.currentUser.company && that.currentUser.company.logo) ||
            that.currentUser.avatar ||
            that.currentUser.selectedAvatarUrl ||
            '',
          sendName:
            (that.currentUser.company && that.currentUser.company.companyName) ||
            (that.currentUser.memberCard && that.currentUser.memberCard.contact) ||
            '',
          receiveUrl: that.otherUserInfo.pic || '',
          receiveName:
            that.otherUserInfo.companyName || that.otherUserInfo.contact || that.otherUserInfo.mchcompanyName || '',
          em_ignore_notification: '1',
        }

        let url

        msg.set({
          apiUrl: this.$WebIM.config.apiURL,
          file,
          to: that.otherUserInfo.huanxinId,
          ext,
          roomType: false,
          onFileUploadError(error) {
            that.$message.error('图片上传失败')
            that.$refs.fileDom.value = null
            console.log('图片上传失败', error)
          },
          onFileUploadComplete(data) {
            console.log('onFileUploadComplete', data)
            url = `${data.uri}/${data.entities[0].uuid}`
            that.$refs.fileDom.value = null
          },
          success(data, id) {
            try {
              console.log('success', data, id)

              const msgInfo = {
                is_self: 1,
                from: that.currentUser.id,
                to: that.currentSession.id,
                url,
                contentsType: 'IMAGE',
                time: new Date().getTime(),
              }

              console.log('图片发送成功', data)
              msgInfo.id = id
              that.addMessage(msgInfo)

              const saveInfo = {
                toMemberCode:
                  that.otherUserInfo.memunicode || that.otherUserInfo.memUnicode || that.otherUserInfo.huanxinId,
                lastMessage: '[图片]',
              }
              if (!that.token) {
                saveInfo.visitorHuanxinId = that.visitorUser.huanxinId
              }

              setSaveChat(saveInfo)
            } catch (err) {
              console.log('err', err)
            }
          },
        })

        this.$WebIM.conn.send(msg.body)
      } catch (err) {
        console.log('err', err)
      }
    },
    // 发送文件消息
    // 单聊发送文件消息 fileType: FILE VIDEO
    /**
     *  @param {('FILE' | 'VIDEO')} fileType 文件类型
     * */

    sendPrivateFile(e, fileType) {
      console.log('sendPrivateFile', e, fileType)
      const file = this.$WebIM.utils.getFileUrl(e.target) // 将文件转化为二进制文件
      if (!file.filename) {
        this.$refs.fileDom.value = null
        return false
      }
      // 文件大小限制
      if (file.data.size / (1024 * 1024) > 50) {
        this.$message.error('文件大小最大限制50M。')
        this.$refs.fileDom.value = null
        return false
      }
      const that = this
      const id = this.$WebIM.conn.getUniqueId() // 生成本地消息id
      const msg = new this.$WebIM.message(fileType === 'FILE' ? 'file' : 'video', id) // 创建文件消息

      const ext = {
        sendUrl:
          (that.currentUser.company && that.currentUser.company.logo) ||
          that.currentUser.avatar ||
          that.currentUser.selectedAvatarUrl ||
          '',
        sendName:
          (that.currentUser.company && that.currentUser.company.companyName) ||
          (that.currentUser.memberCard && that.currentUser.memberCard.contact) ||
          '',
        receiveUrl: that.otherUserInfo.pic || '',
        receiveName:
          that.otherUserInfo.companyName || that.otherUserInfo.contact || that.otherUserInfo.mchcompanyName || '',
        em_ignore_notification: '1',
      }

      const videoAllowType = {
        mp4: true,
        wmv: true,
        avi: true,
        rmvb: true,
        mkv: true,
      }

      const saveInfo = {
        toMemberCode: that.otherUserInfo.memunicode || that.otherUserInfo.memUnicode || that.otherUserInfo.huanxinId,
        lastMessage: file.filename || '[文件]',
      }

      // 消息列表对象
      const msgInfo = {
        is_self: 1,
        // 文件大小
        file_length: file.data.size,
        // 文件名称
        filename: file.filename,
        from: this.currentUser.id,
        to: this.currentSession.id,
        url: undefined,
        contentsType: fileType,
        time: new Date().getTime(),
      }

      if (fileType !== 'FILE' ? file.filetype.toLowerCase() in videoAllowType : true) {
        msg.set({
          apiUrl: this.$WebIM.config.apiURL,
          file,
          to: this.otherUserInfo.huanxinId, // 接收消息对象
          chatType: 'singleChat', // 设置单聊
          onFileUploadError() {
            // 文件上传失败
            this.$message.error('上传失败。')
          },
          onFileUploadComplete(data) {
            // 文件上传成功
            msgInfo.url = `${data.uri}/${data.entities[0].uuid}`
          },
          success(id, serverMsgId) {
            msgInfo.id = serverMsgId
            // 消息发送成功
            that.addMessage(msgInfo)

            if (!that.token) {
              saveInfo.visitorHuanxinId = that.visitorUser.huanxinId
            }
            setSaveChat(saveInfo)
          },
          fail(e) {
            that.$message.error(e.reason || e.type)
          },
          flashUpload: this.$WebIM.flashUpload,
          ext,
          roomType: false,
        })
        this.$WebIM.conn.send(msg.body)
      } else {
        this.$message.error('格式不支持。')
        this.$refs.fileDom.value = null
      }
    },
    // 视频呼叫对方
    videoCall() {
      const userName = this.otherUserInfo.huanxinId
      console.log('toCall', this.otherUserInfo, userName, this.$WebIM.call)
      this.$nextTick(() => {
        this.$WebIM.call.caller = userName
        this.$WebIM.call.makeVideoCall(userName, null, false, false, {
          push: true, // 对方(app端)不在线时是否推送
          timeoutTime: 3, // 超时时间
        })

        this.$store.commit('chat/INIT_WEBRTC_BASEINFO', {
          userName: this.otherUserInfo.userName,
          avatar: this.otherUserInfo.memberAvatar || this.otherUserInfo.companyLogo,
        })
        this.$store.commit('chat/switchEmediaModalVisible', true)
      })
    },
    // 音频呼叫对方
    audioCall() {
      const userName = this.otherUserInfo.huanxinId
      console.log('toCall', this.otherUserInfo, userName, this.$WebIM.call)
      this.$nextTick(() => {
        this.$WebIM.call.caller = userName
        this.$store.commit('chat/INIT_WEBRTC_BASEINFO', {
          userName: this.otherUserInfo.userName,
          avatar: this.otherUserInfo.memberAvatar || this.otherUserInfo.companyLogo,
        })
        this.$WebIM.call.makeVoiceCall(userName, null, false, false, {
          push: true, // 对方(app端)不在线时是否推送
          timeoutTime: 3, // 超时时间
        })
        this.$store.commit('chat/switchEmediaModalVisible', true)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-text {
  position: relative;
  width: 100%;
  background: #fff;

  //工具栏
  .toolBox {
    position: relative;
    display: flex;
    background: #fff;
    padding: 10px;

    .imgBtn {
      color: #bbbbbb;
      font-size: 20px;
      margin-right: 15px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        color: #9e9e9e;
      }
    }
  }

  textarea {
    padding: 10px;
    resize: none;
    width: 100%;
    height: 75%;
    border: none;
    outline: none;
  }

  .seadRow {
    position: absolute;
    background: #fff;
    width: 100%;
    height: 45px;
    bottom: 0;
    padding: 5px 0;

    .sendBtn {
      position: absolute;
      width: 80px;
      height: 35px;
      bottom: 10px;
      right: 10px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
}

.text-footer {
  display: flex;
  height: 60px;
  background: #fff;
  justify-content: flex-end;
  align-items: flex-end;

  button {
    background: #fff;
    padding: 3px 20px;
    color: #222;
    border: 1px solid #c1c1c1;
    border-radius: 3px;
  }

  span {
    font-size: 14px;
    color: #999;
    margin-right: 10px;
  }
}
</style>
